module.exports = __webpack_public_path__ + "img/Z81_05.0093f8cb.jpg";